import { useState } from 'react';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

export const CategoryTreeItem = ({
  item,
  categorySelectedToCkeckBox,
  setCategorySelectedToCkeckBox,
  withoutCategoryValue,
}) => {
  const [isExapanded, setIsExapanded] = useState(false);

  const handleClickCheckbox = (item) => {
    let currentCategories = categorySelectedToCkeckBox || [];

    // Quitamos "SIN_CATEGORIA" si el usuario selecciona una categoría real
    currentCategories = currentCategories.filter((id) => id !== withoutCategoryValue);

    let newCategories;

    if (currentCategories.length > 0) {
      if (!currentCategories.includes(item._id)) {
        newCategories = [...currentCategories, item._id];
      } else {
        newCategories = currentCategories.filter((id) => id !== item._id);
      }
    } else {
      newCategories = [item._id];
    }

    setCategorySelectedToCkeckBox(newCategories);
  };

  const handleClickItem = () => {
    if (item.children.length === 0) {
      handleClickCheckbox(item);
    } else {
      setIsExapanded((oldExpanded) => !oldExpanded);
    }
  };

  return (
    <div className="dad1">
      <div
        onClick={handleClickItem}
        style={{
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
          gap: '0.4rem',
        }}
        className="dad2"
      >
        {item.children.length > 0 ? (
          isExapanded ? (
            <KeyboardArrowDownIcon style={{ cursor: 'pointer' }} />
          ) : (
            <KeyboardArrowRightIcon style={{ cursor: 'pointer' }} />
          )
        ) : (
          <input
            key={item._id}
            type="checkbox"
            style={{ cursor: 'pointer' }}
            checked={categorySelectedToCkeckBox.includes(item._id)}
            onChange={() => handleClickCheckbox(item)}
            onClick={(e) => e.stopPropagation()}
          />
        )}

        <p style={{ margin: '0' }}>{item.name}</p>
      </div>

      {isExapanded &&
        item.children &&
        item.children.map((child) => (
          <div
            style={{
              marginLeft: '1rem',
            }}
            key={child._id}
          >
            <CategoryTreeItem
              item={child}
              categorySelectedToCkeckBox={categorySelectedToCkeckBox}
              setCategorySelectedToCkeckBox={setCategorySelectedToCkeckBox}
              withoutCategoryValue={withoutCategoryValue}
            />
          </div>
        ))}
    </div>
  );
};
